














/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IJobInfo } from '@/types/data-objects/items'
import {
  IPersonWithEmail,
  IStatusForSelection,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'StatusSelectionButton',

  props: {
    status: {
      type: Object as () => IStatusForSelection,
      required: true,
    },
    size: {
      type: String,
      default: 'tiny',
    },
    maxWidth: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },
  },

  computed: {
    chickletType(): string {
      return this.selected ? 'flat' : 'transparent'
    },
    hasJobs(): boolean {
      return this.jobInfo !== null
    },
  },

  methods: {
    // There could be a case where the current assignee IS NOT the mandated assignee
    // (e.g. job rule updated, jobs were turned off before and it was a different assignee).
    // So, only use the assignee mandate if this represents a status that isn't the current one.
    getAssignee(): IPersonWithEmail {
      if (this.status.id === this.jobInfo.currentStatus.id) {
        return this.jobInfo.currentAssignee
      }
      const mandate = this.jobInfo.assigneeMandates.find(
        am => am.statusID === this.status.id,
      )
      return mandate
        ? this.jobInfo.jobAppointees.find(ja => ja.job.id === mandate.jobID)
            .appointee
        : null
    },
  },
})
